import React from "react";
import ReactDOM from "react-dom";
import {withRouter} from "react-router-dom";
import aerial from "../../../../assets/images/icons/service/DroneService.svg"
import floorplans from "../../../../assets/images/icons/service/FloorPlansService.svg"
import other from "../../../../assets/images/icons/service/OtherService.svg"
import photography from "../../../../assets/images/icons/service/PhotographyService.svg"
import video from "../../../../assets/images/icons/service/VideoServiceCreate.svg"
import virtualStaging from "../../../../assets/images/icons/service/StagingService.svg"
import virtualTour from "../../../../assets/images/icons/service/TourService.svg"
import aerialSelected from "../../../../assets/images/icons/service/DroneIconActive.svg"
import floorplansSelected from "../../../../assets/images/icons/service/FloorPlanIconActive.svg"
import photographySelected from "../../../../assets/images/icons/service/PhotoIconActive.svg"
import videoSelected from "../../../../assets/images/icons/service/VideoIconActive.svg"
import virtualStagingSelected from "../../../../assets/images/icons/service/StagingIconActive.svg"
import virtualTourActive from "../../../../assets/images/icons/service/TourIconActive.svg"
import otherActive from "../../../../assets/images/icons/service/OtherIconActive.svg"
import twilightSelected from "../../../../assets/images/icons/service/TwilightServiceActive.svg"
import twilight from "../../../../assets/images/icons/service/TwilightServiceCreate.svg"
import {ReactComponent as CheckMark} from "../../../../assets/images/icons/icon-check.svg";
import {ReactComponent as SmallCheckIcon} from '../../../../assets/images/landing/check-icon.svg'


class ServiceItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showFeaturesModal: false,
      showHoverTooltip: false,
      tooltipPos: null
    }

    this.hoverTimeout = null
    this.hideTimeout = null
    this.titleRef = React.createRef()
    this.updateServiceSelection = this.updateServiceSelection.bind(this)
  }

  isDesktop() {
    return window.matchMedia('(min-width: 751px)').matches
  }

  handleTitleMouseEnter = () => {
    if (this.props.homepage && this.props.service.description && this.isDesktop()) {
      this.hoverTimeout = setTimeout(() => {
        if (this.titleRef.current) {
          const rect = this.titleRef.current.getBoundingClientRect()
          this.setState({showHoverTooltip: true, tooltipPos: rect})
        }
      }, 300)
    }
  }

  handleTitleMouseLeave = () => {
    if (this.hoverTimeout) clearTimeout(this.hoverTimeout)
    this.hideTimeout = setTimeout(() => this.setState({showHoverTooltip: false}), 100)
  }

  handleTooltipMouseEnter = () => {
    if (this.hideTimeout) clearTimeout(this.hideTimeout)
  }

  handleTooltipMouseLeave = () => {
    this.setState({showHoverTooltip: false})
  }

  handleTitleClick = (e) => {
    if (this.props.homepage && this.props.service.description) {
      const selected = this.props.selected || this.props.previouslySelected
      if (selected) e.stopPropagation()
      // Mobile modal disabled — re-enable by uncommenting the block below
      // if (!this.isDesktop()) {
      //   this.setState({showFeaturesModal: true})
      // }
    }
  }

  serviceIcon(slug) {
    const icons = {
      aerial,
      floorplans,
      video,
      photography,
      twilight,
      'virtual-staging': virtualStaging,
      'virtual-tour': virtualTour,
    }
    return icons[slug] || other
  }

  selectedServiceIcon(slug) {
    const icons = {
      'aerial': aerialSelected,
      "floorplans": floorplansSelected,
      "video": videoSelected,
      "twilight": twilightSelected,
      "photography": photographySelected,
      'virtual-staging': virtualStagingSelected,
      "virtual-tour": virtualTourActive
    }
    return icons[slug] || otherActive
  }

  updateServiceSelection() {
    if (this.props.new_order_process){
      if (!this.props.selected && !this.props.previouslySelected) {
        const { service } = this.props
        const eligibleSubServices = service.subServices.filter(s => !s.promo && !s.addon)
        const primaryId = this.props.homepage ? service.homepage_default_sub_service_id : service.default_sub_service_id
        const fallbackId = this.props.homepage ? service.default_sub_service_id : service.homepage_default_sub_service_id
        const subService =
          (primaryId && eligibleSubServices.find(s => s.id === primaryId)) ||
          (fallbackId && eligibleSubServices.find(s => s.id === fallbackId)) ||
          eligibleSubServices.reduce((lowest, s) => lowest.price < s.price ? lowest : s);
        if (this.props.zipcode.length === 5) {
          this.props.toggleSelected(subService, this.props.service)
          // this.props.changeParentState({selected_service: this.props.service.id, currentlySelectedService: this.props.service})
          // this.props.scrollTo('#scrollToHere')
        } else {
          this.props.toggleSelected(subService, this.props.service)
          // this.props.changeParentState({ selected_service: this.props.service.id, currentlySelectedService: this.props.service })
          // this.props.scrollTo('#scrollToHere')
          // this.props.changeParentState({errors: ["Zipcode is required before selecting a service"]})
        }
      } else {
        this.props.removeService(this.props.service)
      }
    } else {
      if (!this.props.selected) {
        if (this.props.zipcode.length === 5) {
          this.props.changeParentState({selected_service: this.props.service.id, currentlySelectedService: this.props.service})
          this.props.scrollTo('#scrollToHere')
        } else {
          this.props.changeParentState({ selected_service: this.props.service.id, currentlySelectedService: this.props.service })
          this.props.scrollTo('#scrollToHere')
          this.props.changeParentState({errors: ["Zipcode is required before selecting a service"]})
        }
      }
    }
  }

  subServices() {
    if (this.props.homepage || !this.props.selectedSubservices) {
      return ''
    }

    return this.props.selectedSubservices.map((subservice, i) => {
      if (this.props.new_order_process || this.props.new_update_process){
        return <div className="serviceSubService">{subservice.title}</div>
      } else {
        return <div className="serviceSubService">{subservice.title}: ${this.props.location_pricing[subservice.id] ? this.props.location_pricing[subservice.id].price : subservice.price || 0}</div>
      }
    })
  }

  render() {
    const service = this.props.service
    const selected = this.props.selected || this.props.previouslySelected
    if (!service.black_icon) service.black_icon = ""
    // const icon = selected ? this.selectedServiceIcon(service.slug) : this.serviceIcon(service.slug)
    const icon = this.serviceIcon(service.slug)

    const hasDescription = !!service.description

    return (
      <div onClick={this.updateServiceSelection}
        className={`serviceItem ${this.props.cancelled ? 'serviceItemCancelled' : ''} ${this.props.new_update_process ? 'serviceItemOnboarding' : ''}${selected ? 'serviceItemSelected' : ''}`} id={`service_${service.id}`} >
        {selected && <div className="checkIcon2">
          <CheckMark/>
        </div>}

        <div className="serviceItemCenter">
          <img src={icon} />

          <div
            className={`serviceItemTitle ${(selected || this.props.cancelled) ? 'serviceItemTitleDark' : ''} ${this.props.homepage && hasDescription ? 'subserviceItemTitleClickable' : ''}`}
            ref={this.titleRef}
            onMouseEnter={this.handleTitleMouseEnter}
            onMouseLeave={this.handleTitleMouseLeave}>
            {service.title}
            {this.state.showHoverTooltip && this.state.tooltipPos && ReactDOM.createPortal(
              <div className="serviceFeaturesTooltip" style={{position: 'fixed', top: this.state.tooltipPos.bottom + 8, left: this.state.tooltipPos.left + this.state.tooltipPos.width / 2, transform: 'translateX(-50%)', zIndex: 100001}} onClick={(e) => e.stopPropagation()} onMouseEnter={this.handleTooltipMouseEnter} onMouseLeave={this.handleTooltipMouseLeave}>
                <div className="serviceFeaturesModalDescription">{service.description}</div>
              </div>,
              document.body
            )}
          </div>

          <div className="serviceSubServices">{this.subServices()}</div>
        </div>

        {this.state.showFeaturesModal && <div className="modal-background" onClick={(e) => { e.stopPropagation(); this.setState({showFeaturesModal: false}) }}>
          <div className="serviceFeaturesModal" onClick={(e) => e.stopPropagation()}>
            <div className="serviceFeaturesModalHeading">{service.title}</div>
            <div className="serviceFeaturesModalDescription">{service.description}</div>
            <div className="text-center mt-3">
              <button className="settingsButton companyButton closeButton m-0" onClick={(e) => { e.stopPropagation(); this.setState({showFeaturesModal: false}) }}>Close</button>
            </div>
          </div>
        </div>}
      </div>
    )
  }
}

export default withRouter(ServiceItem);